// no baseURI

// object to store loaded and loading chunks
// undefined = chunk not loaded, null = chunk preloaded/prefetched
// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
var installedChunks = {
	"polyfills": 0
};

__webpack_require__.f.j = (chunkId, promises) => {
		// JSONP chunk loading for javascript
		var installedChunkData = __webpack_require__.o(installedChunks, chunkId) ? installedChunks[chunkId] : undefined;
		if(installedChunkData !== 0) { // 0 means "already installed".

			// a Promise means "currently loading".
			if(installedChunkData) {
				promises.push(installedChunkData[2]);
			} else {
				if(/^(default\-(node_modules_(aw_(bootstrap\-utils_(dist_aw\-bootstrap\-utils_fesm2022_aw\-bootstrap\-utils_mjs|node_modules_rxjs_dist_esm_internal_operators_auditTi\-b14563)|(file\-upload_fesm2022_aw\-file\-upload|split\-screen_dist_aw\-split\-screen_fesm2022_aw\-split\-screen)_mjs)|n(gx\-(mask_fesm2022_ngx\-mask|translate_core_dist_fesm2022_ngx\-translate\-core)_mjs|oty_lib_noty_js\-webpack_sharing_consume_default_aw_ads\-components_src_s\-68832c)|rxjs_dist_esm_internal_(ReplaySubject_js|operators_auditTime_js\-node_modules_rxjs_dist_esm\-9f2bd5)|((chroma\-js|hammerjs_hammer_js\-node_modules_ng\-click\-outside_lib_esmodule)_index|dropzone_dist_dropzone|luxon_src_luxon)_js)|webpack_sharing_consume_default_aw_ads\-components_aw\-showmore\-text\-angular\-21_aw_ads\-\-f066a0)|node_modules_(a(ngular\-devkit_build\-angular_node_modules_babel_runtime_helpers_esm_asyncToGener\-2ba06e([0-9]|1[0-9])|w_(bootstrap\-utils_node_modules_rxjs_dist_esm_(|operators_)index_js|t(la\-event\-util_(dist_esm_aw\-tla\-event\-util|node_modules_rxjs__esm2015_index)_js|(oken\-parser_dist|s\-fhir\-client_dist_esm)_index_js)|(cms\-client_dist_esm_aw\-cms\-client|i18n_dist_aw\-i18n_esm)_js))|ng\-click\-outside_lib_esmodule_index_js\-(_1957[2-4]|node_modules_angular\-devkit_build\-angular\-06254f[01])|rxjs_dist_esm_(|operators_|webSocket_)index_js|(((elastic_apm\-rum_dist|pdf\-lib)_es|buffer)_index|fhir\-typescript\-models_dist_src_models_all|lodash_lodash)_js)|vendor\-a(ds|ngular)|common|galleria\-docx\-preview|polyfills)$/.test(chunkId)) {
					// setup Promise in chunk cache
					var promise = new Promise((resolve, reject) => (installedChunkData = installedChunks[chunkId] = [resolve, reject]));
					promises.push(installedChunkData[2] = promise);

					// start chunk loading
					var url = __webpack_require__.p + __webpack_require__.u(chunkId);
					// create error before stack unwound to get useful stacktrace later
					var error = new Error();
					var loadingEnded = (event) => {
						if(__webpack_require__.o(installedChunks, chunkId)) {
							installedChunkData = installedChunks[chunkId];
							if(installedChunkData !== 0) installedChunks[chunkId] = undefined;
							if(installedChunkData) {
								var errorType = event && (event.type === 'load' ? 'missing' : event.type);
								var realSrc = event && event.target && event.target.src;
								error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
								error.name = 'ChunkLoadError';
								error.type = errorType;
								error.request = realSrc;
								installedChunkData[1](error);
							}
						}
					};
					__webpack_require__.l(url, loadingEnded, "chunk-" + chunkId, chunkId);
				} else installedChunks[chunkId] = 0;
			}
		}
};

// no prefetching

// no preloaded

// no HMR

// no HMR manifest

// no on chunks loaded

// install a JSONP callback for chunk loading
var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
	var [chunkIds, moreModules, runtime] = data;
	// add "moreModules" to the modules object,
	// then flag all "chunkIds" as loaded and fire callback
	var moduleId, chunkId, i = 0;
	if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
		for(moduleId in moreModules) {
			if(__webpack_require__.o(moreModules, moduleId)) {
				__webpack_require__.m[moduleId] = moreModules[moduleId];
			}
		}
		if(runtime) var result = runtime(__webpack_require__);
	}
	if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
	for(;i < chunkIds.length; i++) {
		chunkId = chunkIds[i];
		if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
			installedChunks[chunkId][0]();
		}
		installedChunks[chunkId] = 0;
	}

}

var chunkLoadingGlobal = self["webpackChunkSecureMessageClient"] = self["webpackChunkSecureMessageClient"] || [];
chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));